import TermsAndConditions from '../modules/TermsAndConditions';
import { HTTP } from 'greenmotion-shared/common/http';

(function () {
    $('.flags img').tooltip();

    $('.flags > ul > li > a').on('click', function (e) {
        e.preventDefault();

        $('.flags a').removeClass('active');
        $(this).addClass('active');

        var country = $(this).data('country-id');

        HTTP.get('/terms-and-conditions?country_id=' + country).then(response => {
            $('.terms-text').html(response.data.data.rendered_conditions);
            TermsAndConditions.wrapTables();

            if (country == 1) {
                $('.additional-info-text').show();
            } else {
                $('.additional-info-text').hide();
            }
        });
    });

    $('.terms .flags .active').click();
})();
